export default "/images/da1ae4560dd0650a0597333080ec27f8.avif";